import * as React from 'react'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import FileListItem from 'modules/tasks/components/FileListItem'

export interface FileData {
  filename: string
  path: string
}

interface Props {
  file: FileData
}

const Default = ({ file }: Props) => {
  return (
    <BoxList>
      <FileListItem
        fileName={file.filename}
        options={[
          {
            href: buildUrl(file.path),
            title: i18n.t('tasks.actions.attachment.download'),
          },
        ]}
      />
    </BoxList>
  )
}

export default observer(Default)
